import { GetEvaluationFormsByJobPostingsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetEvaluationFormsByJobPostings = (ids?: number[]) => {
  const { loading, data } = useQuery(GetEvaluationFormsByJobPostingsDocument, {
    variables: { atsJobPostingIds: ids || [-1] },
    skip: !ids,
  })

  return {
    loading,
    evaluationForms: data?.ats.evaluationFormsConnection.nodes || [],
  }
}
